<template>
  <div class="investors">
    <div class="section-title">
      {{ $t('whatInvestorsSay') }}
    </div>
    <div class="inv-container">
      <div class="inv-left">
        <img :src="imgUrl[index - 1].url" class="img" alt="">
      </div>
      <div class="inv-right">
        <div class="content-container">
          <div class="inv-content">
            <div class="title">{{ investors[index - 1] }}</div>
            <div class="text">
              {{ $t('sayings' + index) }}
            </div>
          </div>
        </div>
        <div class="arrow-container">
          <img class="arrow-icon" src="@/assets/image/home/investors/arrow_left@2x.png"
               @click="changeSummaryDisplay(-1)">
          <img class="arrow-icon" src="@/assets/image/home/investors/arrow_right@2x.png"
               @click="changeSummaryDisplay(1)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  i18n: {
    messages: {
      en: {
        borrower: 'Borrower',
        sayings1:
          'Start funding my money in Kredit Pintar is veeery easy! Especially for myself as a first jobber who has not had any financial experience yet. I was hesitant first, but because I\'m interested in the return rate and convenience, I learned how the start my first lending process. Well, the point is to be patient and sure! Because surely, the fund will increases after the lending period is over. Anyway, thanks Kredit Pintar!',
        sayings2:
          'I am interested in becoming a lender in Kredit Pintar because the funds will be distributed to qualified borrowers, so don\'t be confused and over complicated to find where the funds. Moreover, the process is easy, from the registration process to withdraw the funds back. Kredit Pintar website is also user-friendly, let alone the information is clear, suitable for the curious people who wants to start lending.',
        sayings3:
          'Kredit Pintar provides a secure alternative funding pathway for lenders to diversify their portfolio to get better results than other funding platforms.',
        whatInvestorsSay: 'What Our Lenders Say',
      },
      id: {
        borrower: 'Peminjam',
        sayings1:
          'Mulai pendanaan di Kredit Pintar mudah banget, apalagi buat first jobber kaya aku yang belum punya pengalaman apa-apa. Awalnya sih ragu, tapi karena tertarik sama keuntungan dan kemudahannya, ya aku pelajari gimana prosesnya. Yaa, intinya sih harus sabar dan yakin karena pasti dana akan nambah begitu tenor pendanaan selesai. Pokoknya terima kasih deh Kredit Pintar!',
        sayings2:
          'Menjadi pemberi pinjaman di Kredit Pintar bener-bener mudah! Prosesnya cepat, pemberi pinjaman bisa memilih pendanaan sesuai selera dan risikonya masing-masing. Apalagi website Kredit Pintar sangat user-friendly dan memberikan informasi yang cukup bagi pemberi pinjaman untuk mendapatkan pemahaman lebih lanjut sebelum berpendanaan.',
        sayings3:
          'Kredit Pintar menyediakaan jalur pendanaan alternatif yang aman bagi pemberi pinjaman untuk melakukan diversifikasi portofolio untuk mendapatkan hasil yang lebih baik dibandingkan platform pendanaan lainnya.',
        whatInvestorsSay: 'Apa kata pendana kami',
      },
    },
  },
  data() {
    return {
      index: 1,
      investors: ['Ria Putri', 'Michelle Sudarja', 'Gavin Kristian'],
      imgUrl: [
        {
          url: require('@/assets/image/home/investors/investor1.png'), // eslint-disable-line global-require
        },
        {
          url: require('@/assets/image/home/investors/investor2.png'), // eslint-disable-line global-require
        },
        {
          url: require('@/assets/image/home/investors/investor3.png'), // eslint-disable-line global-require
        },
      ],
    }
  },
  methods: {
    changeSummaryDisplay(offset) {
      this.index += offset
      if (this.index > 3) {
        this.index = 1
      }
      if (this.index < 1) {
        this.index = 3
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.investors {
  overflow: hidden;
  padding: 30px 0 0;
  margin: 0 auto;
}

.borrower-link {
  color: color-primary;
}

.inv-container {
  display: flex;
  flex-direction: column;
}

.inv-left,
.inv-right {
  width: 100%;
}

.inv-left {
  .img {
    width: 100%;
  }
}

.inv-right {
  padding: 24px;
  display: flex;
  flex-direction: column;
  .content-container {
    flex: 1;
  }
  .inv-title {
    .avatar {
      width: 24px;
      height: 24px;
    }
    .title {
      font-size: 20px;
      line-height: 24px;
      padding: 0 16px;
    }
  }
  .inv-content {
    padding: 24px 0;
    .title {
      font-size: 20px;
      font-weight: 400;
      padding-bottom: 16px;
    }
    .text {
      font-size: 16px;
      line-height: 24px;
      color: #444;
    }
  }
  .arrow-container {
    height: 24px;
    .arrow-icon {
      width: 40px;
      height: 20px;
      margin-right: 24px;
      cursor: pointer;
    }
  }
}
</style>
